import actionTypes from '../constants/action-types';

const setMultilingual = (multilingual) => ({
  type: actionTypes.SET_MULTILINGUAL_PROPERTY,
  payload: {
    multilingual,
  },
});

export default setMultilingual;
